// extracted by mini-css-extract-plugin
export default {"container":"search-company-input_container__WK34J","mainButton":"search-company-input_mainButton__ED1Pa","dropdownContainer":"search-company-input_dropdownContainer__SVjzO"};